export const DeliverableType = {
    DISTRO: 'DISTRO',
    APP: 'APP',
    FILE: 'FILE',
    CM4G: 'CM4G',
    BUNDLE: 'BUNDLE',
};
